import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import { login } from '../../redux/Slice/login_logoutSclice';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate()

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')


    const logindata = async (e) => {
        e.preventDefault();
        const res = await fetch('/login', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ email, password })
        })

        const data = await res.json()
        if (data.data === "Success") {
            dispatch(login())
            toast.success('User Login successfull', {
                position: toast.POSITION.TOP_CENTER
            })
            setEmail('')
            setPassword('')
            navigate('/home')

        }

    }
    return (
        <div className='conatiner-fluid signup_container'>
            <div className='row'>

                <div className='col-md-6 col-sm-10 signup_form_left' >
                    <div style={{ fontSize: '1.2rem', color: 'darkgreen' }}>Login</div>
                    <div className="mb-3 mt-3">
                        <label for="uname" className="form-label">Email</label>
                        <input type="text"
                            onChange={(e) => setEmail(e.target.value)}
                            className="form-control" id="uname" placeholder="Enter Email" name="uname" required />

                    </div>
                    <div className="mb-3">
                        <label for="pwd"
                            className="form-label">Password</label>
                        <input type="password"
                            onChange={(e) => setPassword(e.target.value)}
                            className="form-control" id="pwd" placeholder="Enter password" name="pswd" required />

                    </div>

                    <div className='mb-3 mt-2'>
                        <button
                            onClick={logindata}
                            style={{ width: '220px' }} type="submit" className="btn btn-primary">Login Now</button>
                        <ToastContainer />
                    </div>
                    <NavLink to='/forgetPass' onClick={() => document.title = "Forget password..."}>
                        <p style={{ color: 'blue', cursor: 'pointer' }}>forget password ? reset</p>
                    </NavLink>
                    <p>create new account : <NavLink to='/signup'>
                        register
                    </NavLink></p>
                </div>

                <div className='col-md-6 col-sm-10 signup_form_right'>
                    <img src='../images/login.jpg' className='img-fluid' />
                </div>

            </div>
        </div>
    )
}

export default Login;